import React from "react";
import { connect } from "react-redux";
import ApiUrlField from "./ApiUrlField";
import ApiKeyField from "./ApiKeyField";
import ApiUsernameField from "./ApiUsernameField";
import ApiPasswordField from "./ApiPasswordField";
import ApiMonitorUriField from "./ApiMonitorUriField";

function ApiConnectionFieldset() {

    return (
        <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-api">
            <div className="modal-v2-api-sections">
                <div className="modal-v2-api-subsection modal-v2-api-subsection--endpoints">
                    <div className="modal-v2-api-subsection__header">
                        <h4 className="modal-v2-api-subsection__title">Endpoint Details</h4>
                        <p className="modal-v2-api-subsection__caption">Enter the API URL and monitor path first.</p>
                    </div>
                    <ApiUrlField />
                    <ApiMonitorUriField />
                </div>

                <div className="modal-v2-api-subsection modal-v2-api-subsection--credentials">
                    <div className="modal-v2-api-subsection__header">
                        <h4 className="modal-v2-api-subsection__title">Authentication</h4>
                        <p className="modal-v2-api-subsection__caption">Use either an API key or a username and password.</p>
                    </div>

                    <ApiKeyField />

                    <p className="modal-v2-or-divider modal-v2-or-divider--tight">OR</p>

                    <div className="row modal-v2-auth-grid">
                        <div className="col-md-6 modal-v2-auth-col">
                            <ApiUsernameField />
                        </div>
                        <div className="col-md-6 modal-v2-auth-col">
                            <ApiPasswordField />
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
    )
}

export default connect()(ApiConnectionFieldset);
